import { schema } from 'normalizr'

const takeoutOrderItem = new schema.Entity('takeoutOrderItems')

export default takeoutOrderItem
